import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { NgIf, NgFor, NgTemplateOutlet } from '@angular/common';
import { DashboardCard } from '../../../interfaces/strapi';

@Component({
    selector: 'app-slider-component',
    templateUrl: './slider-component.component.html',
    styleUrls: ['./slider-component.component.scss'],
    imports: [
        NgIf,
        NgFor,
        NgTemplateOutlet,
    ],
})
export class SliderComponentComponent implements AfterViewInit, OnDestroy {
  @Input() public carousel: DashboardCard[] = [];

  // @ts-ignore
  @ContentChild(TemplateRef) templateRef: TemplateRef<any> | null;

  @ViewChild('sliderRef') private readonly sliderRef!: ElementRef<HTMLElement>;

  public currentSlideIndex = 0;

  public slider: KeenSliderInstance | null = null;

  ngAfterViewInit() {
    if (this.sliderRef) {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: this.showArrows,
        mode: 'free-snap',
        slides: {
          perView: 1,
          spacing: 15,
        },
        slideChanged: (s) => {
          this.currentSlideIndex = s.track.details.abs;
        },
      });
    }
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  public getArticleSnippet(excerpt: string): string {
    return `${excerpt.slice(0, 60)}...`;
  }

  public get showArrows(): boolean {
    return this.carousel && this.carousel.length > 3;
  }

  public doPrev(): void {
    this.slider?.prev();
  }

  public doNext(): void {
    this.slider?.next();
  }
}
